import { render } from "./DocumentsInfoPanel.vue?vue&type=template&id=698b0254&scoped=true"
import script from "./DocumentsInfoPanel.vue?vue&type=script&lang=js"
export * from "./DocumentsInfoPanel.vue?vue&type=script&lang=js"

import "./DocumentsInfoPanel.vue?vue&type=style&index=0&id=698b0254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698b0254"]])

export default __exports__